const ROLE_ADMINISTRATEUR = 'Administrateur';
const ROLES_ADMIN_ACCEPTES = new Set(['administrateur', 'admininstrateur', 'administrator', 'admin']);

function decoderPayloadJwt(token) {
  if (!token || typeof token !== 'string' || token.split('.').length < 2) {
    return null;
  }

  try {
    const payload = token.split('.')[1];
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - (base64.length % 4)) % 4;
    const padded = `${base64}${'='.repeat(padLength)}`;
    return JSON.parse(window.atob(padded));
  } catch (error) {
    return null;
  }
}

function normaliserRole(role) {
  if (!role || typeof role !== 'string') {
    return '';
  }

  const roleNettoye = role.trim();
  if (roleNettoye.toLowerCase() === 'admininstrateur') {
    return ROLE_ADMINISTRATEUR;
  }

  return roleNettoye;
}

export function obtenirRoleCourant() {
  const accessToken = localStorage.getItem('accessToken');
  const payload = decoderPayloadJwt(accessToken);

  const roleDepuisToken = normaliserRole(
    payload?.role
      || payload?.Role
      || payload?.rolePilotage
      || payload?.RolePilotage
      || payload?.['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']
      || ''
  );

  if (roleDepuisToken) {
    localStorage.setItem('userRole', roleDepuisToken);
    return roleDepuisToken;
  }

  const roleLocal = normaliserRole(localStorage.getItem('userRole') || '');
  if (roleLocal) {
    return roleLocal;
  }

  return '';
}

export function estAdministrateur() {
  const role = normaliserRole(obtenirRoleCourant()).toLowerCase();
  return ROLES_ADMIN_ACCEPTES.has(role) || role === ROLE_ADMINISTRATEUR.toLowerCase();
}

export function effacerRoleCourant() {
  localStorage.removeItem('userRole');
}

export function sauvegarderRoleCourant(role) {
  const roleNormalise = normaliserRole(role);
  if (!roleNormalise) {
    localStorage.removeItem('userRole');
    return;
  }

  localStorage.setItem('userRole', roleNormalise);
}

export async function rafraichirAccessToken() {
  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) {
    return null;
  }

  try {
    const { obtenirUrlControleur } = await import('./urlUtils');
    const lienAuth = obtenirUrlControleur('auth');

    const reponse = await window.fetch(`${lienAuth}/api/auth/renouvellement`, {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ refreshToken }),
    });

    if (!reponse.ok) {
      return null;
    }

    const data = await reponse.json();
    if (data?.accessToken) {
      localStorage.setItem('accessToken', data.accessToken);
    }
    if (data?.refreshToken) {
      localStorage.setItem('refreshToken', data.refreshToken);
    }
    return data?.accessToken || null;
  } catch {
    return null;
  }
}
